import { Application } from "./application";
import { Company } from "./company";
import { Role } from "./role";
import { NameToRole, Role as RoleEnum, RoleName } from "../enums/role.enum";

export class User {
    id?: string;
    login?: string;
    password?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    disabled?: boolean;
    application?: Application;
    company?: Company | null;
    creationDate?: Date;
    creationUser?: User;
    role?: Role;
    role_?: RoleEnum;
    
    constructor(user?: User) {
        this.id = user?.id;
        this.login = user?.login;
        this.firstName = user?.firstName;
        this.lastName = user?.lastName;
        this.email = user?.email;
        this.disabled = user?.disabled;
        this.application = user?.application;
        this.company = user?.company;
        this.creationDate = user?.creationDate;
        this.creationUser = user?.creationUser;
        this.role = user?.role;
        this.role_ = NameToRole.get(user?.role?.name || "");
    }
}
